import { Feature } from '@/@types/featureSwitch';
import { useFeature } from '@/apiHooks/featureSwitches.hook';
import { getAndroidAppBuild, getNativePlatform } from '@/components/native-bridge';

const MIN_BLOCKED_ANDROID_BUILD = 1557;

export const useIsAndroidUpsellBlocked = (): boolean => {
  const blockerEnabled = useFeature(Feature.BLOCK_WOHNEN_PLUS_LIGHT_UPSELL_ANDROID);
  const androidAppBuild = getAndroidAppBuild();

  return (
    blockerEnabled &&
    getNativePlatform() === 'android' &&
    androidAppBuild !== null &&
    androidAppBuild >= MIN_BLOCKED_ANDROID_BUILD
  );
};
